#import "../fragments/context-document-fragment.graphql"

mutation PagesCrawlTrigger($input: PagesCrawlTriggerInput!) {
    pagesCrawlTrigger(input: $input) {
        ...ContextDocumentFragment
    }
}
